import styled from 'styled-components';
import { focusOutline } from '../../utility-classes';
import { TypeStyle } from '../TypeStyle';
export const Body = styled.div `
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;

  ${focusOutline}
  &:focus {
    outline-style: solid;
  }
`;
export const Title = styled(TypeStyle.HeadlineMicro) `
  align-items: ${o => (o.columnLayout ? 'flex-start' : 'center')};
  color: ${o => o.isInvalid ? o.theme.color.deprecated.red.error : o.theme.color.deprecated.obsidian};
  display: inline-flex;
  font-weight: 700;
  justify-content: flex-start;
  line-height: 1.7;
  width: 100%;
  flex-wrap: wrap;
  column-gap: ${o => o.theme.spacing(2)};
  flex-direction: ${o => (o.columnLayout ? 'column' : 'row')};

  > * {
    flex: 0 0 auto;
  }
`;
export const Label = styled.div `
  display: inline-flex;
  align-items: center;
  text-transform: uppercase;

  > * {
    flex: 0 0 auto;
  }
`;
export const Selection = styled(TypeStyle.HeadlineMicro) `
  width: ${o => (o.columnLayout ? '100%' : 'initial')};
  color: ${o => o.theme.color.deprecated.obsidianLighter};
  font-weight: 400;
  flex: 1;
`;
export const Content = styled.div `
  margin-top: 8px;
  width: 100%;
  display: inline-block;
`;
export const EndAdornment = styled.div `
  margin-left: auto;
`;
export const InfoButton = styled.button `
  margin-left: ${o => o.theme.spacing(1.5)};
`;
//# sourceMappingURL=styles.js.map